import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomFormControl, CustomFormGroup, TagField, TagListField } from '@eventlyte/forms';
import {
	ApiErrorList,
	FormErrorsModal,
	RegistrationStepperControls,
	RegistrationStepperProgress,
	ServerErrorsModal
} from '@eventlyte/registration';
import { TranslocoDirective } from '@jsverse/transloco';
import { AppRoutePaths } from '../../app.routes';
import { LocalRegistrationPageBase } from '../../shared/local-registration-page-base';

@Component({
	selector: 'app-registration-question-page',
	imports: [
		RegistrationStepperControls,
		RegistrationStepperProgress,
		ServerErrorsModal,
		FormErrorsModal,
		TranslocoDirective,
		TagField,
		TagListField
	],
	templateUrl: './registration-question-page.html',
	styleUrls: ['./registration-question-page.scss']
})
export class RegistrationQuestionPage extends LocalRegistrationPageBase {
	protected override currentStepNumber = 2;
	protected formGroup = new FormGroup({
		bgovYourIndustrySector: new CustomFormControl('fields.bgovYourIndustrySector.label', [
			this.validators.required()
		]),
		bgovCompanySize: new CustomFormControl('fields.bgovCompanySize.label', [
			this.validators.required()
		]),
		bgovJobRole: new CustomFormControl('fields.bgovJobRole.label', [
			this.validators.required()
		]),
		bgovTechnologiesAndSolutionInterests: new CustomFormControl(
			'fields.bgovTechnologiesAndSolutionInterests.label',
			[this.validators.required()]
		),
		bgovInterestedInNetworkEvents: new CustomFormControl(
			'fields.bgovInterestedInNetworkEvents.label',
			[this.validators.required()]
		),
		bgovBmInterestedInBusinessMatching: new CustomFormControl(
			'fields.bgovBmInterestedInBusinessMatching.label',
			[this.validators.required()]
		)
	});
	protected override exclusiveTagValueByKey: Readonly<Record<string, string>> = {
		bgovInterestedInNetworkEvents: 'I do not have a plan to join'
	};

	public override ngOnInit(): void {
		super.ngOnInit();

		this.formGroups.push(this.formGroup);
		this.validationFormGroups = [new CustomFormGroup({ formGroup: this.formGroups[0] })];
	}

	protected continue(): void {
		super.goToNextStep(this.formGroups, () => {
			this.saving.set(true);

			this.registrationService
				.register(this.recordStateService.getRecord(), false, this.currentStepNumber)
				.subscribe({
					next: () => {
						if (
							this.getRecordValue(this.record, 'bgovBmInterestedInBusinessMatching')
								?.value === 'Interested'
						) {
							this.router.navigate([AppRoutePaths.RegistrationMatching]);
						} else {
							this.router.navigate([AppRoutePaths.RegistrationGroup]);
						}
					},
					error: (apiErrorList: ApiErrorList) => {
						this.serverErrorList.set(apiErrorList);
						this.showServerErrors.set(true);
						this.saving.set(false);
					}
				});
		});
	}
}
